/* eslint-disable import/extensions */
import appConfig from "./feature.config.js";
import tenantConfig from "./tenant.config.js";

// Next.js 15 compatible environment variable access
const NEXT_PUBLIC_ENVIRONMENT_NAME = process.env.NEXT_PUBLIC_ENVIRONMENT_NAME;
const NEXT_PUBLIC_SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
const NEXT_PUBLIC_SENTRY_PROJECT_SLUG =
  process.env.NEXT_PUBLIC_SENTRY_PROJECT_SLUG;
const NEXT_PUBLIC_SENTRY_ORG_SLUG = process.env.NEXT_PUBLIC_SENTRY_ORG_SLUG;

let shouldEnableSentry = false;
if (["pre-main", "main"].includes(NEXT_PUBLIC_ENVIRONMENT_NAME)) {
  shouldEnableSentry =
    appConfig.sentry.prod &&
    tenantConfig.services["a-prime"].integrations.sentry.enabled;
} else {
  shouldEnableSentry = appConfig.sentry.dev;
}

export const IS_SENTRY_ENABLED =
  shouldEnableSentry &&
  [
    NEXT_PUBLIC_SENTRY_DSN,
    NEXT_PUBLIC_SENTRY_PROJECT_SLUG,
    NEXT_PUBLIC_SENTRY_ORG_SLUG,
  ].every((variable) => variable != null);

export const SENTRY_DETAILS = IS_SENTRY_ENABLED
  ? {
      SENTRY_PROJECT_SLUG: NEXT_PUBLIC_SENTRY_PROJECT_SLUG,
      SENTRY_ORG_SLUG: NEXT_PUBLIC_SENTRY_ORG_SLUG,
      SENTRY_DSN: NEXT_PUBLIC_SENTRY_DSN,
    }
  : {
      SENTRY_PROJECT_SLUG: undefined,
      SENTRY_ORG_SLUG: undefined,
      SENTRY_DSN: undefined,
    };
